import InstallationHeaderSection from './InstallationHeaderSection'
import InstallationItemsTableSection from './InstallationItemsTableSection'
import InstallationProductPileSection from './InstallationProductPileSection'
import InstallationPilingSiteSection from './InstallationPilingSiteSection'
import InstallationCraneSection from './InstallationCraneSection'
import InstallationCustomerDutySection from './InstallationCustomerDutySection'
import InstallationContractSection from './InstallationContractSection'
import InstallationFinanceSection from './InstallationFinanceSection'
import InstallationSignaturesSection from './InstallationSignaturesSection'
import InstallationRigFooterSection from './InstallationRigFooterSection'

type ViewModelReturn = ReturnType<typeof import('../../ViewModel').default>

interface Props {
  vm: ViewModelReturn
}

const WorkOpeningNoticeInstallationForm: React.FC<Props> = ({ vm }) => {

  return (
    <>
      <InstallationHeaderSection
        isView={vm.isView}
        headerDoc={vm.headerDoc}
        updateHeaderDoc={vm.updateHeaderDoc}
        sendTo={vm.sendTo}
        setSendTo={vm.setSendTo}
      />

      <InstallationItemsTableSection
        isView={vm.isView}
        items={vm.installationItems}
        addItemRow={vm.addInstallationItemRow}
        removeItemRow={vm.removeInstallationItemRow}
        updateItemRow={vm.updateInstallationItemRow}
      />

      <InstallationProductPileSection
        isView={vm.isView}
        selectedPileSize={vm.installationPileSize}
        setSelectedPileSize={vm.setInstallationPileSize}
      />

      <InstallationPilingSiteSection
        isView={vm.isView}
        pilingSite={vm.pilingSite}
        updatePilingSite={vm.updatePilingSite}
      />

      <InstallationCraneSection
        isView={vm.isView}
        craneSchedule={vm.craneSchedule}
        updateCraneSchedule={vm.updateCraneSchedule}
      />

      <InstallationCustomerDutySection
        isView={vm.isView}
        customerDuty={vm.customerDuty}
        toggleCustomerDuty={vm.toggleCustomerDuty}
        updateCustomerDuty={vm.updateCustomerDuty}
      />

      <InstallationContractSection
        isView={vm.isView}
        contract={vm.installationContract}
        updateContract={vm.updateInstallationContract}
      />

      <InstallationFinanceSection
        isView={vm.isView}
        payment={vm.installationPayment}
        setFinanceStatus={vm.setInstallationFinanceStatus}
        updatePayment={vm.updateInstallationPayment}
      />

      <InstallationSignaturesSection
        isView={vm.isView}
        signatures={vm.signatures}
        updateSignature={vm.updateSignature}
      />

      <InstallationRigFooterSection
        isView={vm.isView}
        rigFooter={vm.rigFooter}
        updateRigFooter={vm.updateRigFooter}
      />
    </>
  )
}

export default WorkOpeningNoticeInstallationForm
